import React from 'react';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import Headline from 'components/headline';
import JointHolderDecisionDispatcher from 'components/jointHolders/jointHoldersDecisionDispatcher';
import { Form } from 'react-redux-form';
import { ProfileStep1Form } from 'components/newAccountSteps/profileSteps/profileStep1Form';
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
import { TRADITIONAL } from 'constants/userProfile';
import { checkUserInvestmentTypeAndReturnActiveOne } from 'utilities/userProfile';
import { formatText } from 'core/i18n';
import { getCountries } from '../utils/getCountries';
import { getOpenCredit } from '../utils/getOpenCredit';
import { getProvinces } from '../utils/getProvinces';
import { useOpenCredit } from './hooks/useOpenCredit';

export const FormBuilder = ({
    cms,
    handleAddressUpdate,
    handleCancel,
    handleEnableSubmit,
    handleNextStep,
    handleSave,
    handleSubmit,
    isClicked,
    onHandleValidateFields,
    options,
    scorings,
    userProfile,
    userProfileForm,
}) => {
    const { creditCardOffer_accepted: creditCardOfferAccepted, documentType } = userProfile;

    const { isOpenCreditActive } = useOpenCredit(creditCardOfferAccepted);

    const showJointHolderDecision = () => {
        const { isJointHolder, investmentType } = userProfile;
        const userInvestmentType = checkUserInvestmentTypeAndReturnActiveOne(investmentType);

        return (
            <ConditionalToggling condition={!isJointHolder && userInvestmentType[TRADITIONAL]}>
                <div className="md-form-group form__input">
                    <JointHolderDecisionDispatcher handleSave={handleSave} />
                </div>
            </ConditionalToggling>
        );
    };

    const isValidForm = userProfileForm.$form.valid;
    const isDisabled = !isValidForm || isClicked;
    const ML2 = scorings.getIn(['ml2', 'scoringStatus']) === 'approved' ?? false;
    const opencredit = ML2 && isOpenCreditActive ? getOpenCredit({ cms, scorings }) : null;
    const { birthCountries, nationalityCountries } = getCountries({ documentType, options });

    const continueButtonClass = `form__button roadmap-navigation__button-continue form__button-primary ${
        isDisabled ? 'disable-styles' : ''
    }`;

    return (
        <Form
            classname="profile-step-1-form"
            model="userProfile"
            onSubmit={handleSubmit}
            onChange={handleEnableSubmit}
            aria-label="Contact information"
        >
            <Headline icon="cliente" className="prospects-gutter">
                <h2>{formatText('stepsTitles-CompleteGeneralData')}</h2>
            </Headline>
            <ProfileStep1Form
                handleSave={handleSave}
                handleNextStep={handleNextStep}
                showJointHolderDecision={showJointHolderDecision()}
                birthCountries={birthCountries}
                nationalityCountries={nationalityCountries}
                handleAddressUpdate={handleAddressUpdate}
                showOpenCredit={opencredit}
                getProvinces={() => getProvinces({ options })}
                showAdditionalDataAdvise={!isDisabled}
            />
            <div className="row form__footer">
                <div className="col-lg-12">
                    <RoadmapNavigation
                        buttonContinueType={'submit'}
                        buttonPrevHidden
                        buttonContinueClass={continueButtonClass}
                        buttonCancelAction={handleCancel}
                        buttonContinueAction={onHandleValidateFields}
                    />
                </div>
            </div>
        </Form>
    );
};
